import { useAuth0 } from '@auth0/auth0-react';
import type { FunctionComponent } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';

export const Protected: FunctionComponent = () => {
  const { isLoading, isAuthenticated } = useAuth0();
  const { pathname, search } = useLocation();

  if (isLoading) {
    return null;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" state={{ from: `${pathname}${search}` }} replace />;
};
